import { z } from "zod";
import { incidentContainerSchema } from "./incident-containers.js";
export const documentCategory = {
    APPOINTMENT_OF_EXPERT: "APPOINTMENT_OF_EXPERT",
    ARCHIVE: "ARCHIVE",
    ASSISTANCE_EVENT_MESSAGE: "ASSISTANCE_EVENT_MESSAGE",
    ASSUMPTION_OF_MANDATE: "ASSUMPTION_OF_MANDATE",
    ATTORNEY_FEE: "ATTORNEY_FEE",
    AVIS: "AVIS",
    BILLING_LETTER_INSURANCE: "BILLING_LETTER_INSURANCE",
    BILLING_LETTER_LAWYER: "BILLING_LETTER_LAWYER",
    BILLING_LETTER_OPPOSING_INSURANCE: "BILLING_LETTER_OPPOSING_INSURANCE",
    CARRIER: "CARRIER",
    CLAIM_AGAINST_OPPOSING_INSURANCE: "CLAIM_AGAINST_OPPOSING_INSURANCE",
    CLAIM_TO_CUSTOMER: "CLAIM_TO_CUSTOMER",
    CLAIM_TO_INSURANCE: "CLAIM_TO_INSURANCE",
    CLAIMINI_INCIDENT_REPORT: "CLAIMINI_INCIDENT_REPORT",
    CONFIRMATION_OF_COST_ABSORPTION: "CONFIRMATION_OF_COST_ABSORPTION",
    CONTRACT: "CONTRACT",
    CONTRACT_TERMS: "CONTRACT_TERMS",
    CORRESPONDENCE_BROKER: "CORRESPONDENCE_BROKER",
    CORRESPONDENCE_DRIVER: "CORRESPONDENCE_DRIVER",
    CORRESPONDENCE_FLEET_MANAGER: "CORRESPONDENCE_FLEET_MANAGER",
    CORRESPONDENCE_FROM_OPPOSING_INSURANCE_COMPANY: "CORRESPONDENCE_FROM_OPPOSING_INSURANCE_COMPANY",
    CORRESPONDENCE_INSURANCE: "CORRESPONDENCE_INSURANCE",
    CORRESPONDENCE_LAWYER: "CORRESPONDENCE_LAWYER",
    CORRESPONDENCE_LEASING: "CORRESPONDENCE_LEASING",
    CORRESPONDENCE_OF_ACCIDENT_PARTNERS: "CORRESPONDENCE_OF_ACCIDENT_PARTNERS",
    CORRESPONDENCE_POLICE_OR_PROSECUTOR: "CORRESPONDENCE_POLICE_OR_PROSECUTOR",
    CORRESPONDENCE_SERVICE_PROVIDER: "CORRESPONDENCE_SERVICE_PROVIDER",
    CORRESPONDENCE_VEHICLE_FLEET: "CORRESPONDENCE_VEHICLE_FLEET",
    CORRESPONDENCE_WITH_EXPERTS: "CORRESPONDENCE_WITH_EXPERTS",
    CORRESPONDENCE_WORKSHOP: "CORRESPONDENCE_WORKSHOP",
    COST_ESTIMATE: "COST_ESTIMATE",
    COVER_LETTER: "COVER_LETTER",
    CREDIT_FROM_SUPPLIER: "CREDIT_FROM_SUPPLIER",
    CREDIT_TO_CUSTOMER: "CREDIT_TO_CUSTOMER",
    CREDIT_TO_INSURANCE: "CREDIT_TO_INSURANCE",
    CREDIT_TO_OTHERS: "CREDIT_TO_OTHERS",
    DELIVERY_NOTE: "DELIVERY_NOTE",
    DEMAND: "DEMAND",
    DOCUMENT: "DOCUMENT",
    DRIVER_LICENCE: "DRIVER_LICENCE",
    DUNNING: "DUNNING",
    EMAIL_OUTPUT: "EMAIL_OUTPUT",
    ERROR_MEMORY_PROTOCOL: "ERROR_MEMORY_PROTOCOL",
    EXPERT_OPINION: "EXPERT_OPINION",
    EXTERNAL_RELEASE: "EXTERNAL_RELEASE",
    GAME_DAMAGE_CERTIFICATE: "GAME_DAMAGE_CERTIFICATE",
    INITIAL_QUANTIFICATION: "INITIAL_QUANTIFICATION",
    INVESTIGATION_FILE: "INVESTIGATION_FILE",
    INVOICE_FROM_SUPPLIER: "INVOICE_FROM_SUPPLIER",
    JUNK: "JUNK",
    LAWSUIT_ASSESSMENT: "LAWSUIT_ASSESSMENT",
    LAWYER_INCIDENT_REPORT: "LAWYER_INCIDENT_REPORT",
    LEASING_FINAL_ACCOUNT: "LEASING_FINAL_ACCOUNT",
    LEASING_RETURN_REPORT: "LEASING_RETURN_REPORT",
    LOSS_REPORT: "LOSS_REPORT",
    OTHER: "OTHER",
    PARTS_DELAYED_PROOF: "PARTS_DELAYED_PROOF",
    PHOTO: "PHOTO",
    "PHOTO:MAIN": "PHOTO:MAIN",
    PHOTO_SHEET: "PHOTO_SHEET",
    POLICE_ACCIDENT_NOTIFICATION: "POLICE_ACCIDENT_NOTIFICATION",
    POWER_OF_ATTORNEY: "POWER_OF_ATTORNEY",
    PROOF_OF_REPAIR: "PROOF_OF_REPAIR",
    PROTOCOL: "PROTOCOL",
    REGULATION_RELEASE: "REGULATION_RELEASE",
    RELEASE_OF_ACTION: "RELEASE_OF_ACTION",
    RELEASE_REQUEST: "RELEASE_REQUEST",
    REPAIR_APPROVAL: "REPAIR_APPROVAL",
    REPAIR_DURATION_CONFIRMATION: "REPAIR_DURATION_CONFIRMATION",
    REPAIR_ORDER: "REPAIR_ORDER",
    REPAIR_SCHEDULE: "REPAIR_SCHEDULE",
    REPORTING: "REPORTING",
    RESIDUAL_VALUE_OFFERS: "RESIDUAL_VALUE_OFFERS",
    RETURN_PROTOCOL: "RETURN_PROTOCOL",
    SKETCH: "SKETCH",
    STATEMENT: "STATEMENT",
    SUBSEQUENT_QUANTIFICATION: "SUBSEQUENT_QUANTIFICATION",
    SUPPLEMENTARY_REPORT: "SUPPLEMENTARY_REPORT",
    TAKEOVER_CONFIRMATION_PROTOCOL: "TAKEOVER_CONFIRMATION_PROTOCOL",
    TEST_REPORT: "TEST_REPORT",
    VEHICLE_DATA: "VEHICLE_DATA",
    VEHICLE_LIST: "VEHICLE_LIST",
    "VOUCHER:EXTERNAL": "VOUCHER:EXTERNAL",
    "VOUCHER:INTERNAL": "VOUCHER:INTERNAL",
    WHEEL_ALIGNMENT_PROTOCOL: "WHEEL_ALIGNMENT_PROTOCOL",
};
export const documentCategorySchema = z.enum(documentCategory);
export const documentCategoryLabel = {
    APPOINTMENT_OF_EXPERT: "Gutachterbeauftragung",
    ARCHIVE: "Archiv",
    ASSISTANCE_EVENT_MESSAGE: "Assistance Ereignismeldung",
    ASSUMPTION_OF_MANDATE: "Mandatsübernahme",
    ATTORNEY_FEE: "RAG Rechtsanwaltsgebührenabrechnung",
    AVIS: "Avis",
    BILLING_LETTER_INSURANCE: "Abrechnungsschreiben von Versicherung",
    BILLING_LETTER_LAWYER: "Abrechnungsschreiben von Rechtsanwalt",
    BILLING_LETTER_OPPOSING_INSURANCE: "Abrechnungsschreiben von gegnerische Versicherung",
    CARRIER: "Begleitschreiben",
    CLAIM_AGAINST_OPPOSING_INSURANCE: "Forderung an gegnerische Versicherung",
    CLAIM_TO_CUSTOMER: "Rechnung an Kunde",
    CLAIM_TO_INSURANCE: "Rechnung an Versicherung",
    CLAIMINI_INCIDENT_REPORT: "claimini Ereignismeldung",
    CONFIRMATION_OF_COST_ABSORPTION: "Kostenübernahmebestätigung",
    CONTRACT: "Vertrag",
    CONTRACT_TERMS: "Vertragsbedingungen/AKBs",
    CORRESPONDENCE_BROKER: "Korrespondenz Makler",
    CORRESPONDENCE_DRIVER: "Korrespondenz Fahrer/Fahrzeugnutzer",
    CORRESPONDENCE_FLEET_MANAGER: "Korrespondenz Fuhrparkmanager",
    CORRESPONDENCE_FROM_OPPOSING_INSURANCE_COMPANY: "Korrespondenz gegnerische Versicherung",
    CORRESPONDENCE_INSURANCE: "Korrespondenz Versicherung",
    CORRESPONDENCE_LAWYER: "Korrespondenz Rechtsanwalt",
    CORRESPONDENCE_LEASING: "Korrespondenz Leasing",
    CORRESPONDENCE_OF_ACCIDENT_PARTNERS: "Korrespondenz Unfallgegner",
    CORRESPONDENCE_POLICE_OR_PROSECUTOR: "Korrespondenz Polizei/Staatsanwaltschaft",
    CORRESPONDENCE_SERVICE_PROVIDER: "Korrespondenz Dienstleister",
    CORRESPONDENCE_VEHICLE_FLEET: "Korrespondenz Fuhrpark",
    CORRESPONDENCE_WITH_EXPERTS: "Korrespondenz Gutachter",
    CORRESPONDENCE_WORKSHOP: "Korrespondenz Werkstatt",
    COST_ESTIMATE: "Kostenvoranschlag",
    COVER_LETTER: "Schutzbrief",
    CREDIT_FROM_SUPPLIER: "Gutschrift von Lieferant",
    CREDIT_TO_CUSTOMER: "Gutschrift an Kunde",
    CREDIT_TO_INSURANCE: "Gutschrift an Versicherung",
    CREDIT_TO_OTHERS: "Gutschrift an Sonstige",
    DELIVERY_NOTE: "Lieferschein",
    DEMAND: "Rechnung an Sonstige",
    DOCUMENT: "Beleg",
    DRIVER_LICENCE: "Führerschein",
    DUNNING: "Mahnung",
    EMAIL_OUTPUT: "E-Mail Ausgang",
    ERROR_MEMORY_PROTOCOL: "Fehlerspeicherprotokoll",
    EXPERT_OPINION: "Gutachten",
    EXTERNAL_RELEASE: "Freigabe (extern)",
    GAME_DAMAGE_CERTIFICATE: "Wildschadenbescheinigung",
    INITIAL_QUANTIFICATION: "Erstbezifferung",
    INVESTIGATION_FILE: "Ermittlungsakte",
    INVOICE_FROM_SUPPLIER: "Rechnung von Lieferant",
    JUNK: "Junk",
    LAWSUIT_ASSESSMENT: "Klageeinschätzung",
    LAWYER_INCIDENT_REPORT: "Ereignismeldung (Rechtsanwalt)",
    LEASING_FINAL_ACCOUNT: "Leasing Endabrechnung",
    LEASING_RETURN_REPORT: "Leasingrückläufer-Gutachten",
    LOSS_REPORT: "Ereignismeldung",
    OTHER: "Sonstige",
    PARTS_DELAYED_PROOF: "Nachweis Ersatzteilverzug",
    PHOTO: "Foto",
    "PHOTO:MAIN": "Foto (Haupt)",
    PHOTO_SHEET: "Fotobogen",
    POLICE_ACCIDENT_NOTIFICATION: "Polizeiliche Unfallmitteilung",
    POWER_OF_ATTORNEY: "Vollmacht",
    PROOF_OF_REPAIR: "Reparaturnachweis",
    PROTOCOL: "Protokoll",
    REGULATION_RELEASE: "Regulierungsfreigabe",
    RELEASE_OF_ACTION: "Klagefreigabe",
    RELEASE_REQUEST: "Freigabeanfrage",
    REPAIR_APPROVAL: "Reparaturfreigabe",
    REPAIR_DURATION_CONFIRMATION: "Reparaturdauerbestätigung",
    REPAIR_ORDER: "Reparaturauftrag",
    REPAIR_SCHEDULE: "Reparaturablaufplan",
    REPORTING: "Reporting",
    RESIDUAL_VALUE_OFFERS: "Restwertgebote",
    RETURN_PROTOCOL: "Rückgabeprotokoll",
    SKETCH: "Skizze",
    STATEMENT: "Stellungnahme",
    SUBSEQUENT_QUANTIFICATION: "Folgebezifferung",
    SUPPLEMENTARY_REPORT: "Nachtragsgutachten",
    TAKEOVER_CONFIRMATION_PROTOCOL: "Übernahmebestätigung/-protokoll",
    TEST_REPORT: "Prüfbericht",
    VEHICLE_DATA: "Fahrzeugdaten/-unterlagen",
    VEHICLE_LIST: "Fahrzeugliste",
    "VOUCHER:EXTERNAL": "Fremdbeleg",
    "VOUCHER:INTERNAL": "Interner Beleg",
    WHEEL_ALIGNMENT_PROTOCOL: "Achsmessprotokoll",
};
export const attachmentCategorySchema = z.object({
    fileName: z.string(),
    url: z.string(),
    category: documentCategorySchema,
});
// Form-state schema for per-attachment category selection. `category` is
// `null` until the reviewer picks a value; submit validators upgrade this to
// "required" via a refine.
export const attachmentCategoryEntrySchema = z.object({
    fileName: z.string(),
    url: z.string(),
    category: documentCategorySchema.nullable(),
});
/** Attachment category plus the eClaim containers it should be linked to. Shared by task types that link documents to multiple containers. */
export const attachmentCategoryWithContainersSchema = attachmentCategorySchema.extend({
    containers: z.array(incidentContainerSchema).default([]),
});
export const attachmentCategoryWithContainersEntrySchema = attachmentCategoryWithContainersSchema.extend({
    category: attachmentCategorySchema.shape.category.nullable(),
});
